(function (angular) {
    "use strict";
    var fmgApp = angular.module('FmgProduceSuite-Launcher');

    fmgApp.factory('connectionService', function ($http,app_env) {

        var svc = {};

        svc.gateway = function(){
            return $http.get(app_env.baseUrl+'alive');
        };

        return svc;
    });


}) (window.angular);